import React from "react";
import PropTypes from "prop-types";
import { ReachMenuItem, ReachMenuLink } from "./menu-button-pieces";
import Icon from "./icon";

var ActionsMenuItem = function ActionsMenuItem(_ref) {
  var option = _ref.option,
      setMountedItem = _ref.setMountedItem;
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, option.icon && /*#__PURE__*/React.createElement(Icon, {
    icon: option.icon,
    iconKit: option.iconKit,
    style: option.iconStyle,
    className: "et--actions-menu--menu-icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "et--actions-menu--menu-option-label"
  }, option.label), option.description ? /*#__PURE__*/React.createElement("div", {
    className: "et--actions-menu--menu-option-description"
  }, option.description) : null));
  return option.href ? /*#__PURE__*/React.createElement(ReachMenuLink, {
    disabled: option.disabled,
    className: "et--actions-menu--menu-option is-link",
    as: option.as,
    href: option.href,
    target: option.target,
    title: option.title
  }, content) : /*#__PURE__*/React.createElement(ReachMenuItem, {
    disabled: option.disabled,
    title: option.title,
    className: "et--actions-menu--menu-option is-button",
    onSelect: function onSelect() {
      if (typeof option.mountOnClick === "function") {
        setMountedItem(option.mountOnClick({
          is_open: true,
          close: function close() {
            return setMountedItem(null);
          }
        }));
      } else {
        option.onClick();
      }
    }
  }, content);
};

ActionsMenuItem.defaultProps = {
  iconKit: "gt"
};
ActionsMenuItem.propTypes = {
  setMountedItem: PropTypes.func.isRequired,
  option: PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.string,
    iconKit: PropTypes.string,
    iconStyle: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    as: PropTypes.string,
    target: PropTypes.string,
    mountOnClick: PropTypes.func,
    onClick: PropTypes.func
  }).isRequired
};
export default ActionsMenuItem;